function init() {
	setGlobalVariables();
	setPathLenght();
	makeElementSquare();
	detectUrlChange();
	headerVisibility();
	homeProductState();
}

function homeProductState(){

	if(window.utils.isMobile()){
		var elems = document.querySelectorAll(".home .single-product"); // Seleziona gli elementi da monitorare

		if(elems.length > 0){
			window.utils.forEach(elems, function (index, elem) {
				window.addEventListener("scroll", function () {
					if(window.utils.elementIsVisibleInViewport(elem)){
						elem.classList.add("active");
					} else {
						elem.classList.remove("active");
					}
				});
			});
		}
	}
}

function setGlobalVariables(){

	setContainerMarginVariable();
	setRealVhValue();

	window.addEventListener('resize', () => {
		
		setContainerMarginVariable();
		makeElementSquare();
		setRealVhValue();
		
	});

}

function setPathLenght(){
	var paths = document.querySelectorAll('.decor path');

	if(paths.length > 0){
		window.utils.forEach(paths, function (index, path) {
			var length = path.getTotalLength();
			
			path.style.strokeDasharray = length;
			path.style.strokeDashoffset = length;
			
		});
	}
}

function detectUrlChange(){
	var prevUrl = undefined;
	setInterval(() => {
		var currUrl = window.location.href;

		if (currUrl != prevUrl) {
			prevUrl = currUrl;
			makeElementSquare();
		}

	}, 60);
}

function makeElementSquare(){

	var squares = document.querySelectorAll(".squares, .square");

	if (squares.length > 0) {
		window.utils.forEach(squares, function (index, square) {
			var squareWidth = square.offsetWidth;
			square.style.height = squareWidth + "px";
		});
	}
}

function setContainerMarginVariable(){

	var container = document.querySelector('.container');
	if(container){
		var style = container.currentStyle || window.getComputedStyle(container),
			marginLeft = style.marginLeft,
			width = style.width;

		if(!marginLeft){
			marginLeft = 0;
		}

		document.documentElement.style.setProperty('--smx-container-margin', `${marginLeft}`);
		document.documentElement.style.setProperty('--smx-container-margin-nagative', `-${marginLeft}`);
		document.documentElement.style.setProperty('--smx-container-width', `${width}`);
	}

}

function setRealVhValue(){
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function headerVisibility() {
	var mainHeader = document.getElementById("main-header");

	window.addEventListener("scroll", function () {
		var scrollTop = document.documentElement.scrollTop;
		if (scrollTop >= 150) {
			mainHeader.classList.add("scrolled");
		} else {
			mainHeader.classList.remove("scrolled");
		}
	});

	var lastScrollTop = 0;

	window.addEventListener(
		"scroll",
		function () {
			var scrollTop = document.documentElement.scrollTop;

			if (scrollTop >= 150) {
				mainHeader.classList.add("scrolled");
				mainHeader.addEventListener(
					"transitionend",
					function () {
						if (!mainHeader.classList.contains("has-scrolled")) {
							mainHeader.classList.add("has-scrolled");
						}
					},
					{
						once: true,
					}
				);
			} else {
				mainHeader.classList.remove("scrolled");
				mainHeader.addEventListener(
					"transitionend",
					function () {
						if (mainHeader.classList.contains("has-scrolled")) {
							mainHeader.classList.remove("has-scrolled");
						}
					},
					{
						once: true,
					}
				);
			}

			if (scrollTop < lastScrollTop) {
				mainHeader.classList.add("scroll-up");
				document.body.classList.add("scroll-up");
			} else {
				mainHeader.classList.remove("scroll-up");
				document.body.classList.remove("scroll-up");
			}

			lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
		},
		false
	);
}

export default { init };